import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractFile, NextcloudFile } from 'src/app/classes';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-file-tile-entry',
  templateUrl: './file-tile-entry.component.html',
  styleUrls: ['./file-tile-entry.component.css']
})
export class FileTileEntryComponent implements OnInit {

  private _file = new ReplaySubject<AbstractFile>(1);
  @Input() set file(file: AbstractFile){
    this._file.next(file);
  }

  fileName$ = this._file.pipe(map(x => {
    if(x.isNextcloudFile) return FileService.getFileName(decodeURIComponent((x as NextcloudFile).href));
    return 'Datei';
  }));
  fileType$ = combineLatest([this.fileName$, this._file]).pipe(map(([fileName, file]) => {
    var extension = null;
    if(typeof fileName === 'string'){
      let array = fileName.split('.');
      if(array.length > 1) extension = array[array.length - 1];
    }
    return FileService.getFileType(file? file.type: null, extension);
  }));

  constructor(
    private _fileService: FileService
  ) { }

  ngOnInit(): void {
  }

}
